/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Exocet Counter — animated number reveal for stat values.
 * Opt-in via data-counter on the element holding the rendered value.
 * Parses prefix/number/decimals/suffix from textContent so "4.9/5", "2,500+",
 * "40+", "227L" all count correctly and keep their suffix. Non-numeric values
 * (e.g. "#1") are left static. Values are never hardcoded — always read from the DOM.
 */
(function () {
  "use strict";

  var BOUND = "data-counter-bound";

  function pluginsReady() {
    return typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined";
  }

  function reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function parseValue(text) {
    var match = text.match(/^(\D*?)([\d.,]+)(.*)$/);
    if (!match) return null;
    var raw = match[2].replace(/,/g, "");
    var number = parseFloat(raw);
    if (!isFinite(number)) return null;
    var dot = raw.indexOf(".");
    return {
      prefix: match[1],
      number: number,
      decimals: dot >= 0 ? raw.length - dot - 1 : 0,
      grouped: match[2].indexOf(",") >= 0,
      suffix: match[3],
    };
  }

  function format(value, spec) {
    var fixed = value.toFixed(spec.decimals);
    if (spec.grouped) {
      var parts = fixed.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      fixed = parts.join(".");
    }
    return spec.prefix + fixed + spec.suffix;
  }

  function init(root) {
    root.querySelectorAll("[data-counter]").forEach(function (el) {
      if (el.hasAttribute(BOUND)) return;
      var spec = parseValue((el.textContent || "").trim());
      if (!spec) return; // leave non-numeric values (e.g. "#1") exactly as rendered
      el.setAttribute(BOUND, "");

      // Do NOT pre-zero the text — the server value stays until the count fires in view.
      var state = { value: 0 };
      gsap.to(state, {
        value: spec.number,
        duration: 0.9,
        ease: "power2.out",
        onUpdate: function () {
          el.textContent = format(state.value, spec);
        },
        onComplete: function () {
          el.textContent = format(spec.number, spec);
        },
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          once: true,
        },
      });
    });
  }

  function boot(root) {
    // On reduced-motion or GSAP failure the rendered value simply stays (final, correct).
    if (!pluginsReady() || reducedMotion()) return;
    gsap.registerPlugin(ScrollTrigger);
    init(root);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      boot(event.target);
    });
  }

  window.ExocetCounter = {
    refresh: function () {
      if (pluginsReady()) ScrollTrigger.refresh();
    },
    boot: boot,
  };

  if (window.ExocetMotion) {
    ExocetMotion.register(window.ExocetCounter);
  }
})();
